<template>
  <div class="rds-alert-container">
    <div class="rds-alert-overlay"></div>
    <div class="rds-alert">
      <div class="rds-alert-header">
        <span>{{title}}</span>
      </div>
      <div class="rds-alert-body">
        <span v-html="text"></span>
      </div>
      <div class="rds-alert-footer">
        <div class="alert-button skip-button" v-on:tap="onCancel" v-if="showCancelButton">X</div>
        <img
          class="alert-button confirm-button"
          v-on:tap="onConfirm"
          src="../assets/images/life_confirm_v1.svg"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RdsAlert',
  props: ['title', 'text', 'showCancel'],
  computed: {
    showCancelButton() {
      return typeof this.showCancel === 'boolean' ? this.showCancel : true;
    }
  },
  methods: {
    onConfirm() {
      this.$emit('alertConfirm');
    },
    onCancel() {
      this.$emit('alertCancel');
    }
  }
};
</script>
<style lang="scss" scoped>
.rds-alert-container,
.rds-alert-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
}
.rds-alert-overlay {
  opacity: 0.76;
  background-color: #ffffff;
}
.rds-alert {
  border-radius: $default-border-radius 24px;
  left: 50%;
  top: 50%;
  width: calc(100% - (24px * 2) - (29px * 2));
  z-index: 5;
  position: absolute;
  background-color: #1d2e90;
  color: #ffffff;
  padding: 24px;
  transform: translate(-50%, -50%);
  .rds-alert-header {
    font-size: 1.3em;
    letter-spacing: 1px;
    margin-top: 7px;
  }
  .rds-alert-body {
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.87em;
    padding: $default-padding 0;
    letter-spacing: 1px;
    line-height: 19px;
  }
  .rds-alert-footer {
    display: flex;
    justify-content: flex-end;
  }
  .alert-button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    & + .alert-button {
      margin-left: 8px;
    }
  }
  .skip-button {
    background-color: #2886c1;
    padding: 0 21px;
  }
  .confirm-button {
    background-color: #00868c;
  }
}
</style>
